import { Breadcrumb, Button, Col, Image, Row, Steps, message } from "antd";
import CWLayout from "../cwLayout";
import "./cwPrefactor.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import {
	complexDigitToman,
	convertToJalaliWithTime,
	convertToJalaliWithoutTime,
	fileToBase64,
	formatMsisdn,
	getFieldDocumentText,
	isEmpty,
	isEmptyObject,
} from "../../../../tools/tools";
import IncressCharge from "../../../auxiliary/incressCharge/charge";
import Loading from "../../../auxiliary/loader/loading";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { globalValue } from "../../../../reducer/serviceReducerGlobala";
import { simcardPurchase } from "../../../../reducer/serviceReducer";

const CWPrefactor = () => {
	const [t] = useTranslation("global");
	const { changeOwnerPreFactor, querySPPurchaseVProfileDealerById, calculateCOCommissionPrice } = useDealer();
	const { queryTaxPercent } = useAPIPublic();
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	const nav = useNavigate();
	const [searchParam] = useSearchParams();

	const bankRef = useRef("");

	//state for details profile
	const [seller, setSeller] = useState({});
	const [documentSeller, setDocumentSeller] = useState();
	const [buyer, setBuyer] = useState({});
	const [documentBuyer, setDocumentBuyer] = useState();

	const [isLoading, setIsLoading] = useState(false);
	const [localInvoiceId, setLocalInvoiceId] = useState("");

	const [isVisibleBuyer, setIsVisibleBuyer] = useState(false);
	const [isVisibleSeller, setIsVisibleSeller] = useState(false);

	const [purchaseOwner, setPurchaseOwner] = useState();

	const [messageApi, contextHolder] = message.useMessage();

	//price
	const [wallet, setWallet] = useState(0);
	const [taxPercent, setTaxPercent] = useState(0);
	const [calcTax, setCalcTax] = useState(0);
	const [commission, setCommission] = useState(0);
	const [profit, setProfit] = useState(0);
	const [totalPay, setTotalPay] = useState(0);

	const [tobeContinue, setTobeContinue] = useState(true);

	// Incress Charge
	const [openIncress, setOpenIncress] = useState(false);

	console.log(formData);

	useEffect(() => {
		setWallet(formData?.another?._currentUser?.walletAmount);
	}, [formData?.another?._currentUser?.walletAmount]);

	useEffect(() => {
		const initialState = async () => {
			if (!isEmpty(searchParam.get("localInvoiceId"))) {
				setSeller(formData?.another?.changeownership?.seller);
				setBuyer(formData?.another?.changeownership?.buyer);

				formData.from = formData?.another?.changeownership;
				setLocalInvoiceId(searchParam.get("localInvoiceId"));
				setOpenIncress(true);
				intialGetProfile(formData?.another?.changeownership?.seller?.msisdn);
				const sellerDoc = await fileToBase64(formData?.another?.changeownership?.seller?.photo);
				setDocumentSeller(sellerDoc);
				const BuyerDoc = await fileToBase64(formData?.another?.changeownership?.buyer?.profile?.photo);
				setDocumentBuyer(BuyerDoc);
			} else {
				setSeller(formData?.from?.changeownership?.seller || formData?.another?.changeownership?.seller);
				setBuyer(formData?.from?.changeownership?.buyer || formData?.another?.changeownership?.buyer);
				intialGetProfile(formData?.from?.changeownership?.seller?.msisdn, formData?.another?.changeownership?.seller?.msisdn);
				const sullerDoc = await fileToBase64(formData?.from?.changeownership?.seller?.photo || formData?.another?.changeownership?.seller?.photo);
				setDocumentSeller(sullerDoc);
				const BuyerDoc = await fileToBase64(
					formData?.from?.changeownership?.buyer.profile?.photo || formData?.another?.changeownership?.buyer.profile?.photo,
				);
				setDocumentBuyer(BuyerDoc);
			}
		};
		initialState();
	}, []);

	const intialGetProfile = async (msisdn) => {
		try {
			setIsLoading(true);
			if (msisdn?.length > 0) {
				let payload = {
					msisdn: msisdn,
				};
				let response = await changeOwnerPreFactor(payload);
				if (response) {
					setPurchaseOwner(response);
					// setCommission(response?.commission);
					setCommission(response?.changeDealerWalletAmount);
					// setProfit(response?.changeDealerWalletAmount + response?.iccidCommission);
					setProfit(response?.changeDealerWalletAmount);

					let responseProfile = await querySPPurchaseVProfileDealerById(response?.spPurchaseId);
					if (responseProfile) {
						setSeller((prev) => ({ ...prev, profile: { ...responseProfile } }));
					}
					let resTax = await queryTaxPercent();
					if (resTax) {
						setTaxPercent(resTax);
					}
					let payloadCommission = {
						sppurchaseproductid: response?.spPurchaseId,
					};
					let resGetCommission = await calculateCOCommissionPrice(payloadCommission);
					if (resGetCommission) {
						setCommission(resGetCommission.changeDealerWalletAmount);
					}
					setTobeContinue(false);
				} else {
					setTobeContinue(true);
				}
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (!isEmptyObject(purchaseOwner) && taxPercent > 0) {
			calculate();
		}
	}, [purchaseOwner, taxPercent]);

	const calculate = () => {
		let _bundlePrice = purchaseOwner?.coSalesCommission;
		let _taxPay = (_bundlePrice * taxPercent) / 100;
		let _totalPrice = _bundlePrice + _taxPay;

		setTotalPay(_totalPrice);
		setCalcTax(_taxPay);
	};

	const handleCallBackCharge = (value) => {
		if (value?.length > 0) {
			// dispatch(clearFormData());
			dispatch(globalValue({ changeownership: { ...formData.from } }));
			bankRef.current.innerHTML = value;
			document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
		} else {
			setLocalInvoiceId("");
			setOpenIncress(false);
		}
	};
	const handleSubmitPage = async () => {
		if (!tobeContinue) {
			setIsLoading(true);
			if (wallet - totalPay >= commission) {
				dispatch(
					simcardPurchase({
						changeownership: {
							buyer: { ...buyer },
							seller: { ...seller },
							prefactor: { ...purchaseOwner },
						},
					}),
				);
				nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Document);
			} else {
				messageApi.open({
					type: "error",
					content: "موجودی کیف پول کافی نمی باشد.",
				});
			}
			setIsLoading(false);
		}
	};
	return (
		<CWLayout>
			{contextHolder}
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.ownership.title")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className="g-body-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={3}
										items={[
											{
												title: "اطلاعات فروشنده",
											},
											{
												title: "اطلاعات خریدار",
											},
											{
												title: "آپلود مدرک شناسایی",
											},
											{
												title: "پیش فاکتور",
											},
											{
												title: "سند",
											},
										]}
									/>
								</div>
							</div>
							<div className="cw-prefactor">
								<div className="g-prefactor">
									<div className="holder-row-prefactor">
										<Row gutter={16}>
											<Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
												<div className="for-pay-client">
													<h3>صورت حساب مشتری</h3>
													<div className="holder-box">
														<div className="holder-simcard">
															<div className="holder-list-msisdn">
																<div>
																	<div className="item">
																		<div className="row-item">
																			<div className="holder-icon">
																				<i className="icon-simcard"></i>
																			</div>
																			<div className="holder-text">
																				<h4>
																					<span dir="ltr">{formatMsisdn(seller?.msisdn?.slice(1))}</span>
																				</h4>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<h4>
																اطلاعات فروشنده{" "}
																<Link
																	to={
																		_adr.Root +
																		_adr.ChangeOwnerShip.Index +
																		_adr.ChangeOwnerShip.OwnerShip.Index +
																		_adr.ChangeOwnerShip.OwnerShip.InformationSeller
																	}>
																	<i className="icon-edit"></i>
																</Link>
															</h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">نام:</div>
																	<div className="value">{seller?.profile?.stR_FName}</div>
																</div>
																<div className="item">
																	<div className="label">نام خانوادگی:</div>
																	<div className="value">{seller?.profile?.stR_LName}</div>
																</div>
																<div className="item">
																	<div className="label">نوع مدرک شناسایی:</div>
																	<div className="value">{getFieldDocumentText(seller?.profile?.inT_CertType)}</div>
																</div>
																<div className="item">
																	<div className="label">تاریخ تولد:</div>
																	<div className="value">
																		{seller?.profile?.dtE_BirthDate && convertToJalaliWithTime(seller?.profile?.dtE_BirthDate)}
																	</div>
																</div>
																<div className="item">
																	<div className="label">نام پدر:</div>
																	<div className="value">{seller?.profile?.stR_FatherName}</div>
																</div>
																<div className="item">
																	<div className="label">شماره مدرک شناسایی:</div>
																	<div className="value">{seller?.profile?.stR_CertNo}</div>
																</div>
																<div className="item">
																	<div className="label">جنسیت:</div>
																	<div className="value">{seller?.profile?.inT_Gender === 1 ? <>مرد</> : <>زن</>}</div>
																</div>
																{/* {seller?.profile?.txtCountry?.length > 0 && (
                                  <div className="item">
                                    <div className="label">کشور:</div>
                                    <div className="value">{seller?.profile?.txtCountry}</div>
                                  </div>
                                )} */}
																<div className="item">
																	<div className="label">موبایل:</div>
																	<div className="value" dir="ltr">
																		0{formatMsisdn(seller?.smsmobile?.slice(1))}
																	</div>
																</div>
																{seller?.profile?.stR_Email?.length > 0 && (
																	<div className="item">
																		<div className="label">پست الکترونیکی:</div>
																		<div className="value">{seller?.profile?.stR_Email}</div>
																	</div>
																)}

																<div className="item">
																	<div className="label">تصویر کارت ملی:</div>
																	<div className="value">
																		<div className="show-document">
																			<Button onClick={() => setIsVisibleSeller(true)} type="link">
																				بارگذاری شده
																			</Button>
																			<Image
																				preview={{
																					visible: isVisibleSeller,
																					onVisibleChange: (value) => setIsVisibleSeller(value),
																				}}
																				src={documentSeller}
																				style={{ display: "none" }}
																			/>
																		</div>
																	</div>
																</div>
																<div className="item">
																	<div className="label">استان:</div>
																	<div className="value">{seller?.profile?.province?.stR_ProvinceName}</div>
																</div>
																<div className="item">
																	<div className="label">شهر:</div>
																	<div className="value">{seller?.profile?.city?.stR_CityName}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان اصلی:</div>
																	<div className="value">{seller?.profile?.address?.stR_MainStreet}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان فرعی:</div>
																	<div className="value">{seller?.profile?.address?.stR_AuxiliaryRoad}</div>
																</div>
																<div className="item">
																	<div className="label">کوچه:</div>
																	<div className="value">{seller?.profile?.address?.stR_Alley}</div>
																</div>
																<div className="item">
																	<div className="label">پلاک:</div>
																	<div className="value">{seller?.profile?.address?.stR_BuildingNo}</div>
																</div>
																<div className="item">
																	<div className="label">طبقه:</div>
																	<div className="value">{seller?.profile?.address?.stR_Floor}</div>
																</div>
																<div className="item">
																	<div className="label">واحد:</div>
																	<div className="value">{seller?.profile?.address?.stR_Unit}</div>
																</div>
																<div className="item">
																	<div className="label">کدپستی:</div>
																	<div className="value">{seller?.profile?.address?.stR_PostalCode}</div>
																</div>
															</div>
															<div className="divider"></div>
															<h4>
																اطلاعات خریدار{" "}
																<Link
																	to={
																		_adr.Root +
																		_adr.ChangeOwnerShip.Index +
																		_adr.ChangeOwnerShip.OwnerShip.Index +
																		_adr.ChangeOwnerShip.OwnerShip.Profile
																	}>
																	<i className="icon-edit"></i>
																</Link>
															</h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">نام:</div>
																	<div className="value">{buyer?.profile?.fname}</div>
																</div>
																<div className="item">
																	<div className="label">نام خانوادگی:</div>
																	<div className="value">{buyer?.profile?.lname}</div>
																</div>
																<div className="item">
																	<div className="label">نوع مدرک شناسایی:</div>
																	<div className="value">{getFieldDocumentText(buyer?.profile?.certtype)}</div>
																</div>
																<div className="item">
																	<div className="label">تاریخ تولد:</div>
																	<div className="value">{buyer?.profile?.birthdate && convertToJalaliWithoutTime(buyer?.profile?.birthdate)}</div>
																</div>
																<div className="item">
																	<div className="label">نام پدر:</div>
																	<div className="value">{buyer?.profile?.fathername}</div>
																</div>
																<div className="item">
																	<div className="label">شماره مدرک شناسایی:</div>
																	<div className="value">{buyer?.profile?.certno}</div>
																</div>
																<div className="item">
																	<div className="label">جنسیت:</div>
																	<div className="value">{buyer?.profile?.txtGender}</div>
																</div>
																{buyer?.profile?.txtCountry?.length > 0 && (
																	<div className="item">
																		<div className="label">کشور:</div>
																		<div className="value">{buyer?.profile?.txtCountry}</div>
																	</div>
																)}
																<div className="item">
																	<div className="label">موبایل:</div>
																	<div className="value" dir="ltr">
																		0{formatMsisdn(buyer?.profile?.smsmobileno?.slice(1))}
																	</div>
																</div>
																{buyer?.profile?.email?.length > 0 && (
																	<div className="item">
																		<div className="label">پست الکترونیکی:</div>
																		<div className="value">{buyer?.profile?.email}</div>
																	</div>
																)}

																<div className="item">
																	<div className="label">تصویر کارت ملی:</div>
																	<div className="value">
																		<div className="show-document">
																			<Button onClick={() => setIsVisibleBuyer(true)} type="link">
																				بارگذاری شده
																			</Button>
																			<Image
																				preview={{
																					visible: isVisibleBuyer,
																					onVisibleChange: (value) => setIsVisibleBuyer(value),
																				}}
																				src={documentBuyer}
																				style={{ display: "none" }}
																			/>
																		</div>
																	</div>
																</div>
																<div className="item">
																	<div className="label">استان:</div>
																	<div className="value">{buyer?.profile?.txtProvince}</div>
																</div>
																<div className="item">
																	<div className="label">شهر:</div>
																	<div className="value">{buyer?.profile?.txtCity}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان اصلی:</div>
																	<div className="value">{buyer?.profile?.mainstreet}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان فرعی:</div>
																	<div className="value">{buyer?.profile?.auxiliaryroad}</div>
																</div>
																<div className="item">
																	<div className="label">کوچه:</div>
																	<div className="value">{buyer?.profile?.alley}</div>
																</div>
																<div className="item">
																	<div className="label">پلاک:</div>
																	<div className="value">{buyer?.profile?.buildingno}</div>
																</div>
																<div className="item">
																	<div className="label">طبقه:</div>
																	<div className="value">{buyer?.profile?.floor}</div>
																</div>
																<div className="item">
																	<div className="label">واحد:</div>
																	<div className="value">{buyer?.profile?.unit}</div>
																</div>
																<div className="item">
																	<div className="label">کدپستی:</div>
																	<div className="value">{buyer?.profile?.postalcode}</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</Col>
											<Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
												<div className="for-pay-agent">
													<h3>صورت حساب فروشنده</h3>
													<div className="holder-box">
														<div className="holder-list-pay">
															<ul>
																<li>
																	<div className="label">هزینه تغییر مالکیت</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(purchaseOwner?.coSalesCommission))}</span> <small>تومان</small>
																	</div>
																</li>
																<li>
																	<div className="label">مالیات ({taxPercent}درصد)</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(calcTax))}</span> تومان
																	</div>
																</li>

																<li>
																	<div className="label">مبلغ قابل دریافت از مشتری</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(totalPay))}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">{commission > 0 ? <> مبلغ واریز به کیف پول</> : <>مبلغ برداشت از کیف پول</>}</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(commission))}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">سود شما از تغییر مالکیت</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(totalPay - commission))}</span> تومان
																	</div>
																</li>
															</ul>
															{wallet >= commission ? (
																<div className="hold-message success">
																	<p>این مبلغ از کیف پول شما برداشت می‌شود</p>
																	<h3>
																		{" "}
																		<span dir="ltr">{complexDigitToman(Math.abs(commission))}</span> تومان
																	</h3>
																</div>
															) : (
																<div className="hold-message error">
																	<div className="row-message">
																		<div className="holder-text">
																			<h3>اعتبار شما کافی نمی‌باشد</h3>
																			<ul>
																				<li>
																					<div className="label">کسری اعتبار: </div>
																					<div className="value">
																						<span dir="ltr">{complexDigitToman(Math.abs(wallet + commission))} </span> تومان
																					</div>
																				</li>
																			</ul>
																		</div>
																		<div className="holder-acction">
																			<div className="holder-button">
																				<Button className="btn-normal btn-aptel" htmlType="button" onClick={() => setOpenIncress(true)}>
																					افزایش اعتبار
																				</Button>
																			</div>
																		</div>
																	</div>
																</div>
															)}
														</div>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</div>
						</div>
						<div className="g-footer-format-page">
							<div className="holder-button">
								<Button
									onClick={() => {
										handleSubmitPage();
									}}
									disabled={tobeContinue}
									className={`btn-normal btn-aptel ${tobeContinue ? "disabled" : ""}`}>
									ادامه
								</Button>
								<Button
									onClick={() =>
										nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.SwapDocument)
									}
									className="btn-normal">
									بازگشت
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</div>
			<IncressCharge
				open={openIncress}
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_CW}
				msisdn={formData?.another?._currentUser?.telnoone}
				price={Math.abs(commission)}
				callback={handleCallBackCharge}
				localInvoiceId={localInvoiceId}
			/>

			<Loading isOpen={isLoading} />
			{/* <div ref={bankRef}></div> */}
		</CWLayout>
	);
};

export default CWPrefactor;
